import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  Agent,
  CreateIncentiveRequest,
  CreateIncentiveResponse,
  IncentiveState,
  UpdateIncentiveRequest,
} from 'redux/types/Incentive.types';

export const incentiveInitialState: IncentiveState = {
  incentives: [],
  selectedIncentive: null,
  agents: [],
  loading: false,
  error: null,
  success: false,
};

const incentiveSlice = createSlice({
  name: 'incentive',
  initialState: incentiveInitialState,
  reducers: {
    getIncentives: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    getIncentivesSuccess: (state, action: PayloadAction<any>) => {
      state.incentives = action.payload;
      state.loading = false;
      state.error = null;
    },
    getIncentiveById: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
      state.selectedIncentive = null;
    },
    getIncentiveByIdSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = null;
      state.selectedIncentive = action.payload;
    },
    getIncentiveByIdFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.selectedIncentive = null;
    },
    getIncentivesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    createIncentive: (state, action: PayloadAction<CreateIncentiveRequest>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    createIncentiveSuccess: (
      state,
      action: PayloadAction<CreateIncentiveResponse>
    ) => {
      state.loading = false;
      state.error = null;
      state.success = true;
    },
    createIncentiveFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    editIncentive: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    editIncentiveSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = null;
      state.success = true;
    },
    editIncentiveFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    updateIncentive: (state, action: PayloadAction<UpdateIncentiveRequest>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    resetIncentives: () => incentiveInitialState,
    getAgents: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAgentsSuccess: (state, action: PayloadAction<Agent[]>) => {
      state.agents = action.payload;
      state.loading = false;
      state.error = null;
    },
    getAgentsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getIncentives,
  getIncentivesSuccess,
  getIncentivesFailure,
  getIncentiveById,
  getIncentiveByIdSuccess,
  getIncentiveByIdFailure,
  createIncentive,
  createIncentiveSuccess,
  createIncentiveFailure,
  editIncentive,
  editIncentiveSuccess,
  editIncentiveFailure,
  resetIncentives,
  getAgents,
  getAgentsSuccess,
  getAgentsFailure,
  updateIncentive,
} = incentiveSlice.actions;

export default incentiveSlice.reducer;
